import React from "react";

export const NextSteps = ({ title = "What happens next", steps }) => (
  <section className="my-12 border border-white/10 bg-[#14141A] p-7 md:p-9 glass-card" data-testid="next-steps">
    <div className="flex items-center gap-3 mb-5">
      <span className="h-px w-10 bg-[#E9C76A]" />
      <span className="overline">Process</span>
    </div>
    <h3 className="font-serif text-2xl md:text-3xl text-[#F5F2E8] tracking-tight mb-8">
      {title}
    </h3>
    <ol className="relative pl-6 border-l border-[#E9C76A]/25 space-y-7">
      {steps.map((s, i) => (
        <li key={i} className="relative">
          <span className="absolute -left-[31px] top-1 flex items-center justify-center h-7 w-7 rounded-full bg-[#0B0B0E] border border-[#E9C76A] text-[#E9C76A] text-[11px] font-medium">
            {i + 1}
          </span>
          <div className="overline mb-1">{s.when}</div>
          <div className="font-serif text-lg text-[#F5F2E8] mb-1">{s.title}</div>
          <p className="text-sm text-white/65 leading-relaxed font-light">{s.body}</p>
        </li>
      ))}
    </ol>
  </section>
);
